import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import styles from './Authors.module.css';

import ButtonLink from '../../components/ButtonLink';
import CardAuthor from '../../components/CardAuthor';
import CardBook from '../../components/CardBook';
import Title from '../../components/Title';
import BannerAutor from '../../assets/bannerAutor.png';
import Loading from '../../components/Loading';
import Carousel from '../../components/Carousel';

export default function Authors() {
  const [authors, setAuthors] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    axios.get('https://back-cultura-sje-production.up.railway.app/get-authors', {})
      .then((response) => {
        setAuthors(response.data)})
      .catch((error) => {
        console.error('Erro ao buscar autores', error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500);
      });
  }, []);

  useEffect(() => {
    axios.get('https://back-cultura-sje-production.up.railway.app/get-books', {})
      .then((response) => {
        setBooks(response.data)})
      .catch((error) => {
        console.error('Erro ao buscar livros', error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500);
      });
  }, []);

  if (loading) {
    return <Loading />
  }
  
  return (
    <main className={styles.page}>
      <div className={styles.bannerContainer}>
        <img src={BannerAutor} alt="Banner" />
      </div>
      <div className={styles.container}>
        {authors.length > 0 ?
        <section className={styles.authorContainer}>
          <div className={styles.header}>
            <Title color='var(--brown-300)'>Autores</Title>
            <ButtonLink path='/autores/todos' type='type2'>Ver mais</ButtonLink>
          </div>
          <Carousel 
            itemsPerView={3} 
            autoPlay={true} 
            autoPlayInterval={4000}
          >
            {authors.map(author => (
              <Link to={`/autores/${author.id}`} className={styles.Links}>
                <CardAuthor nomeArtistico={author.nomeArtistico} generoLiterario={author.generoLiterario} foto={author.foto} />
              </Link>
            ))}
          </Carousel>
        </section> : ''}
        
        {books.length > 0 ?
        <section className={styles.booksContainer}>
          <div className={styles.header}>
            <Title color='var(--brown-300)'>Livros</Title>
            <ButtonLink path='/autores/livros' type='type2'>Ver mais</ButtonLink>
          </div>
          <Carousel 
            itemsPerView={3} 
            autoPlay={true} 
            autoPlayInterval={4000}
          >
            {books.map(book => (
              <Link to={`/autores/livros/${book.id}`} className={styles.Links}>
                <CardBook titulo={book.titulo} autor={book.autor.nomeArtistico} genero={book.genero} capa={book.capa} preco={book.preco} />
              </Link>
            ))}
          </Carousel>
        </section> : ''}

        <section className={styles.formsContainer}>
          <h2>Cadastre-se e cadastre seus livros</h2>
          <div className={styles.formButtons}>
            <ButtonLink path='login'>Login</ButtonLink>
            <ButtonLink path='cadastro-de-autores'>Cadastre-se</ButtonLink>
          </div>
        </section>
      </div>
    </main>
  );
}